export const bodyAreas = [
  "Semua Area",
  "Betis (Depan-Belakang)",
  "Paha (Depan-Belakang)",
  "Pinggang Punggung",
  "Pundak Leher Bahu",
  "Lengan",
  "Dada",
  "Perut",
];
